import _ from "lodash";
import * as React from "react";
import * as BS from "react-bootstrap";
import * as RS from "react-select";
import * as Comp from "../../../../components";
import { Paths } from "../../../../constants";
import * as Forms from "../../../../forms";
import * as M from "../../../../models";
import { Api } from "../../../../services/Api";
import { ReactHelper, Utility } from "../../../../utils";

interface OwnProps {
    api: Api;
    formComponent: Comp.Validation.IComponentWithValidatedForm;
}

interface OwnState {
    search: string;
    searchOpen: boolean;
}

export class ReviewersEditor extends React.Component<OwnProps, OwnState> {

    private _confirmDelete: Comp.Modal.ConfirmModal | null = null;
    private _searchTimeout: NodeJS.Timer;
    private _fieldname = "reviewers";

    public constructor(props: any) {
        super(props);
        this.displayUserSuggest = this.displayUserSuggest.bind(this);
        this.searchMember = this.searchMember.bind(this);
        this.state = {
            search: "",
            searchOpen: false,
        };
    }

    public render() {
        const label = this.props.formComponent.getFieldLabel(this._fieldname);

        const errors = this.props.formComponent.getFieldErrors(this._fieldname);
        const formModel = this.props.formComponent.getFormModel() as Forms.Abstract.GradingGroup;
        const users = formModel.data.reviewers
            .filter((x) => !x.isDeleted)
            .map((x, i) => (
                <li key={i}>
                    <Comp.Reusable.PersonSearchListItem
                        avatar={M.Generic.PersonHelper.getAvatarUrl(x)}
                        email={x.username}
                        link={x.legacyMemberId ? Paths.Legacy.AdminMemberProfile(x.legacyMemberId) : undefined}
                        name={M.Generic.PersonHelper.getFullName(x)}
                        title={x.degrees}
                        onDelete={() => {
                            if (x.isNew)
                                this.onDelete(x.index);
                            else
                                this.toggleRemoveConfirmation(x.index);
                        }}
                    />
                </li>));

        return <Comp.Editors.FormField label={label} errors={errors} name="">
            <Comp.Modal.ConfirmModal
                headerClassName="warning"
                onProceed={() => this.handleRemove()}
                title="Remove reviewer"
                ref={(ref) => this._confirmDelete = ref}
            >
                <p>
                    Are you sure you want to remove this reviewer?
                    Any associated abstract grades will also be deleted.
                </p>
            </Comp.Modal.ConfirmModal>

            <ul className="authors" style={{ display: users.length ? "block" : "none" }}>
                {users}
            </ul>

            <div className="clear" />

            <BS.Collapse in={this.state.searchOpen}>
                <div>
                    <RS.Async
                        // ignoreCase={false}
                        cache={false}
                        className="txt-med authors search"
                        loadOptions={(search: string) => this.searchMember(search)}
                        onChange={(s: M.Member.BasicProfile) => this.onAdd(s)}
                        placeholder="Find person&hellip;"
                        searchPromptText="Start typing a person's name and select from suggested"
                        optionRenderer={this.displayUserSuggest}
                        valueRenderer={this.displayUserSuggest}
                    />
                </div>
            </BS.Collapse>

            <div className="clear" />

            <p>
                <a href="#" onClick={(e) => { ReactHelper.emptyClick(e); this.toggleSearchBox(!this.state.searchOpen); }}>Add reviewer</a>
            </p>
        </Comp.Editors.FormField>;
    }

    private displayUserSuggest = (m: M.Member.BasicProfile) => (<li>
        <Comp.Reusable.PersonSearchListItem
            avatar={M.Generic.PersonHelper.getAvatarUrl(m)}
            email={m.username}
            name={M.Generic.PersonHelper.getFullName(m)}
            title={m.degrees}
        />
    </li>)

    private async handleRemove() {
        if (this._confirmDelete === null)
            return;

        const index = this._confirmDelete.getRef() as number;
        if (index !== undefined) {
            this.onDelete(index);
            setTimeout(() => {
                if (this._confirmDelete) this._confirmDelete.close();
            }, 125);
        }
    }

    private toggleRemoveConfirmation(index: number) {
        if (this._confirmDelete !== null)
            this._confirmDelete.show(index);
    }

    private toggleSearchBox(searchOpen: boolean) {
        this.setState({ ...this.state, searchOpen });
    }

    private onAdd(m: M.Member.BasicProfile) {
        if (!m)
            return;

        const formModel = this.props.formComponent.getFormModel<Forms.Abstract.GradingGroupData>();
        const existingItem = _.find(formModel.data.reviewers, (c, i) => c.userId === m.userId);
        const defItem = { ...Forms.Abstract.DefaultGradingGroupReviewer };

        if (!existingItem) {
            formModel.data.reviewers.push({
                ...defItem,
                degrees: m.degrees,
                index: formModel.data.reviewers.length,
                isNew: true,
                firstName: m.firstName || "",
                lastName: m.lastName || "",
                legacyMemberId: m.legacyMemberId,
                profilePicture: m.profilePicture,
                userId: m.userId,
                username: m.username,
            });
        }
        else {
            existingItem.isDeleted = false;
        }

        this.props.formComponent.updateFormModel(formModel);
        this.toggleSearchBox(false);
    }

    private onDelete(idx: number) {
        const formModel = this.props.formComponent.getFormModel<Forms.Abstract.GradingGroupData>();
        const item = _.find(formModel.data.reviewers, (c, i) => c.index === idx);

        if (item) {
            item.isDeleted = true;
            this.props.formComponent.updateFormModel(formModel);
        }
    }

    private searchMember(query: string) {
        if (!query || query.length < 2)
            return Promise.resolve({ options: [] });

        return new Promise((resolve, reject) => {
            // delay the ajax call as to not make a call for each letter typed.
            if (this._searchTimeout !== undefined)
                clearTimeout(this._searchTimeout);

            this._searchTimeout = setTimeout(() => {
                const queryParams = { queryParams: {
                    query,
                    includeNonMembers: false,
                    isAdmin: true,
                    max: 25,
                }};

                this.props.api.callApi(Api.endpoints.members.search, queryParams)
                    .then((result) => {
                        if (result.isSuccess && result.data) {
                            let options = result.data.map((x) => (
                                Utility.toReactSelectOption(x, M.Generic.PersonHelper.getFullName(x), x.userId)
                            ));

                            options = [...options];
                            resolve({ options });
                        }
                        else
                            console.warn("ReviewersEditor error", result.errors.join("; "));
                    });
            }, 375);
        }).then((data) => {
            return data;
        });
    }
}



// WEBPACK FOOTER //
// ./src/containers/adminAbstracts/editGroup/components/ReviewersEditor.tsx